import * as React from 'react'
import { ContainerSearch } from './styles'
import { Button, IconButton, Stack } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import InputBase from '@mui/material/InputBase'
import { Add } from '@mui/icons-material'

type Props = {
  onAction?: () => void
  onActionSearch: (value: any) => void
  onSearchTitle?: string
  onActionTitle?: string
}

export const DataGridHeader = ({ onAction, onActionSearch, onActionTitle = '', onSearchTitle = '' }: Props) => {
  return (
    <Stack
      justifyContent="space-between"
      direction={{ xs: 'column', sm: 'row' }}
      spacing={{ xs: 2, sm: 4, md: 6 }}
      margin={0.5}
    >
      <Stack direction="row" width={{ xs: '100%', md: '65%', sm: '55%' }} >
        <ContainerSearch width={{ xs: '100%', sm: 650 }} >
          <IconButton type="button" sx={{ p: '5px' }} aria-label="search">
            <SearchIcon />
          </IconButton>
          <InputBase
            sx={{ ml: 1, flex: 1 }}
            placeholder={ onSearchTitle }
            onChange={(value) => {
              onActionSearch(value)
            }}
          />
        </ContainerSearch>
      </Stack>
      <Stack>
        { onAction && <Button size="medium" variant="contained" color="primary" startIcon={<Add />} onClick={onAction}>
          { onActionTitle }
        </Button>
        }
      </Stack>
    </Stack>
  )
}
